import React from 'react';
import { FaBars, FaBell, FaUserCircle, FaSearch } from 'react-icons/fa';

const Navbar = ({ toggleSidebar, navigate, isMobile, isSidebarOpen }) => {
  return (
    <header className="bg-white shadow-sm py-3 px-4 fixed top-0 left-0 right-0 z-20">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button 
            onClick={toggleSidebar}
            className="mr-4 text-gray-600 hover:text-gray-800 focus:outline-none"
          >
            <FaBars className="text-xl" />
          </button>
          <h1 className="text-xl font-semibold text-gray-800 hidden md:block">
            Dashboard
          </h1>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="relative hidden md:block">
            <input
              type="text"
              placeholder="Search..."
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <FaSearch className="absolute left-3 top-3 text-gray-400" />
          </div>
          
          <button className="text-gray-600 hover:text-gray-800 relative">
            <FaBell className="text-xl" />
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
              3
            </span>
          </button>
          
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
              <FaUserCircle className="text-blue-600 text-xl" />
            </div>
            {!isMobile && (
              <span className="ml-2 text-sm font-medium text-gray-700">Admin</span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;